import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  public nombrePortal = 'BDC';
  public subNombrePortal = 'Biblioteca Digital de Componentes de integración';
  public versions = [
    {
      version: 'V.3',
      url: environment.cdnVersions.v3
    },
    {
      version: 'V.2',
      url: environment.cdnVersions.v2
    },
    {
      version: 'V.1',
      url: environment.cdnVersions.v1
    }
  ];

  urls = {
    'home': environment.homeUrl,
    'carpetaciudadana': environment.carpetaciudadanaUrl,
    'tramites': environment.tramitesUrl,
    'images': environment.imagesUrl
  };

  public urlRepository: string = environment.repositoryCode.urlBase;

  clickMenuResponsive(event: any) {
    const body = document.getElementsByTagName('body');
    const expanded: any = event.target.getAttribute('aria-expanded');
    if (expanded == 'true') {
      event.target.classList.add('govco-times');
      event.target.classList.remove('govco-bars');
      body[0].classList.add('scrollNone');
    } else {
      event.target.classList.add('govco-bars');
      event.target.classList.remove('govco-times');
      body[0].classList.remove('scrollNone');
    }
  }
}
